/* eslint-disable */
import * as R from 'ramda';
import moment from 'moment';
import { ROLE_MAPPING } from 'dataModule/constants/profile';

const parseMediaUpload = (fileToUpload) => {
  if (fileToUpload && fileToUpload.type && fileToUpload.type.includes('image')) return fileToUpload.base64;
  if (fileToUpload && fileToUpload.type && fileToUpload.type.includes('video')) return fileToUpload.file;
  return fileToUpload;
};

const parseAlerts = (alerts, thresholdType) => {
  const { alertCategory: { oneTime, advanced } = {} } = alerts;
  // Neither one time nor advanced alerts
  if (!R.prop('selected', oneTime) && !R.prop('selected', advanced)) {
    return [];
  }

  const alertCategory = R.prop('selected', advanced) ? 'ADVANCED' : 'ONE-TIME';

  console.log('>> handleCreate parseAlerts alertCategory: ', alertCategory);

  console.log('>> handleCreate parseAlerts alerts: ', alerts);

  const {
    missed: { missed },
    warning: { low, high },
    critical: { criticallyLow, criticallyHigh },
  } = R.prop('alertConfig', R.prop('selected', advanced) ? advanced : oneTime);

  const toNotification = (alertType, alertInput) => {
    const {
      times: { value: times = 1 } = {},
      sendToCareteamVia: { checkeds: careteamCheckeds = {} } = {},
      sendToPatientVia: { checkeds: patientCheckeds = {} } = {},
    } = alertInput;

    const isAlertSet = R.pipe(R.ap([R.values]), R.flatten, R.any(R.identity))([careteamCheckeds, patientCheckeds]);

    return isAlertSet
      ? {
          // eslint-disable-next-line
          alertCategory,
          alertType: alertType === 'missed' ? 'MISSED_READING' : 'THRESHOLD_READING',
          consecutiveCount: times,
          ...(alertType !== 'missed'
            ? {
                trigger: [{ low: 'L', high: 'H', criticallyLow: 'LL', criticallyHigh: 'HH' }[alertType]],
              }
            : {}),
          thresholdType,
          messages: R.pipe(
            R.ap([({ email, sms, inApp }) => R.filter(R.identity, [email && 'EMAIL', sms && 'SMS', inApp && 'INAPP'])]),
            ([careteam, patient]) => [
              { recipient: 'CARETEAM', type: careteam, subject: 'Alert for Care Team' },
              { recipient: 'PATIENT', type: patient, subject: 'Alert for Participant' },
            ],
          )([careteamCheckeds, patientCheckeds]),
        }
      : null;
  };

  const notificationFinal = R.pipe(R.filter(R.identity))([
    toNotification('missed', missed),
    toNotification('low', low),
    toNotification('high', high),
    toNotification('criticallyLow', criticallyLow),
    toNotification('criticallyHigh', criticallyHigh),
  ]);

  console.log('>> handleCreate notificationFinal: ', notificationFinal);

  return notificationFinal;
};

const createQuestionnaire = {
  fe2be: ({
    withMedia,
    information: {
      uuid,
      name,
      category: { value: category },
      specify,
      duration,
      frequency: { value: calendar },
      effectiveFrom,
      effectiveTo,
      description,
      scoreType: { value: scoreType },
    },
    introduction: {
      mediaUrl: introMedia,
      title: introTitle,
      description: introDescription,
      disclaimer: introDisclaimer,
    },
    questions,
    thankyou: { mediaUrl: thankMedia, title: thankTitle, description: thankDescription, disclaimer: thankDisclaimer },
    thresholds: {
      onlineThreshold: { threshold: onlineThreshold, alerts: onlineAlerts },
      offlineThreshold: { threshold: offlineThreshold, alerts: offlineAlerts },
      defaultAlerts: { alerts: defaultAlerts },
      schedule: {
        type: { value: scheduleType },
        frequency,
        timeslots,
        meals,
      },
    },
    summary: {
      hasOfflineSetting,
      onlineMinTotalPoints,
      onlineMaxTotalPoints,
      offlineMinTotalPoints,
      offlineMaxTotalPoints,
    },
  }) => {
    const updatedQuestionsArray = Object.entries(questions).map(([key, question], index) => {
      if (question.type.value === 'SINGLE_SELECTION' || question.type.value === 'MULTIPLE_SELECTION') {
        const updatedAnswers = question.answers.map((answer, index) => ({
          label: answer.label,
          selected: answer.selected,
          order: index + 1,
          point: scoreType === 'POINT' ? answer.points : null,
        }));

        return {
          ...question,
          mediaUrl: '',
          type: question.type.value,
          mandatory: question.mandatory.value,
          whenOffline: question.whenOffline.value,
          hint: question.hint || '',
          disclaimer: question.disclaimer || '',
          answers: updatedAnswers,
          order: index + 1,
        };
      } else if (question.type.value === 'RANGE_SELECTION') {
        const updatedAnswers = question.answers.options.map((answer, index) => ({
          key: answer.key || '',
          label: answer.label,
          order: index + 1,
          point: scoreType === 'POINT' ? answer.points : null,
        }));

        return {
          ...question,
          mediaUrl: '',
          type: question.type.value,
          mandatory: question.mandatory.value,
          whenOffline: question.whenOffline.value,
          hint: question.hint || '',
          disclaimer: question.disclaimer || '',
          scale: {
            from: Number(question.answers.scale.from.value),
            to: question.answers.scale.to.value,
          },
          answers: updatedAnswers,
          order: index + 1,
        };
      } else if (question.type.value === 'FREE_TEXT_ANSWER') {
        return {
          ...question,
          answers: null,
          mediaUrl: '',
          type: question.type.value,
          mandatory: question.mandatory.value,
          whenOffline: question.whenOffline.value,
          hint: question.hint || '',
          disclaimer: question.disclaimer || '',
          point: Array.isArray(question.answers) && question.answers.length > 0 ? question.answers[0].points : 0,
          order: index + 1,
        };
      } else if (question.type.value === 'EMOJI_RATING') {
        const updatedAnswers = question.answers.map((answer, index) => ({
          key: `EMOJI_${index + 1}`,
          label: answer.label,
          order: index + 1,
          point: scoreType === 'POINT' ? answer.points : null,
        }));

        return {
          ...question,
          mediaUrl: '',
          type: question.type.value,
          mandatory: question.mandatory.value,
          whenOffline: question.whenOffline.value,
          hint: question.hint || '',
          disclaimer: question.disclaimer || '',
          answers: updatedAnswers,
          order: index + 1,
        };
      } else if (question.type.value === 'STAR_RATING') {
        const updatedAnswers = question.answers.map((answer, index) => ({
          key: `STAR_${index + 1}`,
          label: answer.label,
          order: index + 1,
          point: scoreType === 'POINT' ? answer.points : null,
        }));

        return {
          ...question,
          mediaUrl: '',
          type: question.type.value,
          mandatory: question.mandatory.value,
          whenOffline: question.whenOffline.value,
          hint: question.hint || '',
          disclaimer: question.disclaimer || '',
          answers: updatedAnswers,
          order: index + 1,
        };
      }
    });

    console.log('>> handleCreate updatedQuestionsArray: ', updatedQuestionsArray);

    let thresholds = null;
    if (scoreType === 'NOT_APPLICABLE') {
      thresholds = {
        default: null,
      };
    } else {
      thresholds = {
        online: [
          onlineThreshold.criticallyLow,
          onlineThreshold.low,
          onlineThreshold.high,
          onlineThreshold.criticallyHigh,
        ],
        offline: !hasOfflineSetting
          ? null
          : (offlineThreshold.criticallyLow === 0 || offlineThreshold.criticallyLow === null) &&
            (offlineThreshold.low === 0 || offlineThreshold.low === null) &&
            (offlineThreshold.high === 0 || offlineThreshold.high === null) &&
            (offlineThreshold.criticallyHigh === 0 || offlineThreshold.criticallyHigh === null)
          ? null
          : [
              offlineThreshold.criticallyLow,
              offlineThreshold.low,
              offlineThreshold.high,
              offlineThreshold.criticallyHigh,
            ],
      };
    }

    const payloadToServer = {
      scoreType,
      withMedia,
      information: {
        uuid,
        name,
        category: {
          key: category,
          value: category === 'OTHERS' ? specify : category,
        },
        duration: {
          length: Number(duration),
          calendar,
        },
        period: {
          start: effectiveFrom ? moment(effectiveFrom).format('YYYY-MM-DD') : null,
          end: effectiveTo ? moment(effectiveTo).format('YYYY-MM-DD') : null,
        },
        description,
        schedule: {
          scheduleType: {
            frequency: 'FREQUENCY',
            timeslots: 'TIMESLOT',
            meals: 'TIMESLOT_MEAL',
          }[scheduleType],
          scheduleDetails: (() => {
            switch (scheduleType) {
              case 'frequency':
                return {
                  frequency: {
                    calendar: R.path(['calendar', 'value'], frequency),
                    times: R.path(['times'], frequency),
                  },
                };
              case 'timeslots':
                return {
                  timeslot: R.map(
                    ({ from, to }) => ({
                      start: `${String(moment(from).hour()).padStart(2, '0')}${String(moment(from).minute()).padStart(
                        2,
                        '0',
                      )}`,
                      end: `${String(moment(to).hour()).padStart(2, '0')}${String(moment(to).minute()).padStart(
                        2,
                        '0',
                      )}`,
                    }),
                    timeslots,
                  ),
                };
              case 'meals':
                return {
                  timeslotMeal: {
                    calendar: 'DAILY',
                    timeslots: (({
                      before: { checkeds: beforeCheckeds = {} } = {},
                      after: { checkeds: afterCheckeds = {} } = {},
                    }) =>
                      R.pipe(
                        R.ap([R.pipe(R.filter(R.identity), R.keys)]),
                        R.flatten,
                        R.map((meal) => ({ meal, times: 1 })),
                      )([beforeCheckeds, afterCheckeds]))(meals),
                  },
                };
              default:
                return {};
            }
          })(),
        },
        scoreType,
        thresholds,
        alerts:
          scoreType === 'NOT_APPLICABLE'
            ? [...parseAlerts(defaultAlerts, 'DEFAULT')]
            : [...parseAlerts(onlineAlerts, 'ONLINE'), ...parseAlerts(offlineAlerts, 'OFFLINE')],
        summary: {
          online: {
            maxScore: onlineMaxTotalPoints,
            minScore: onlineMinTotalPoints,
          },
          offline: {
            maxScore: offlineMaxTotalPoints,
            minScore: offlineMinTotalPoints,
          },
        },
      },
      introduction: {
        // mediaUrl: introMediaUpload,
        mediaUrl: '',
        title: introTitle,
        description: introDescription,
        disclaimer: introDisclaimer,
      },
      questions: updatedQuestionsArray,
      closing: {
        // mediaUrl: thankMediaUpload,
        mediaUrl: '',
        title: thankTitle,
        description: thankDescription,
        disclaimer: thankDisclaimer,
      },
    };

    console.log('>> handleCreate payloadToServer: ', payloadToServer);

    return payloadToServer;
  },
  // be2fe: ({ value: questionnaire }) => {
  //   return questionnaire;
  // },
  be2fe: R.identity,
};

const updateQuestionnaire = createQuestionnaire;

const retrieveQuestionnaires = {
  fe2be: R.identity,
  be2fe: ({ value: { data, pagination } = {} }) => ({
    list: data,
    pagination: {
      currentPage: pagination && R.dec(parseFloat(pagination.page_no)),
      pageSize: pagination && parseFloat(pagination.page_size),
      totalCount: pagination && parseFloat(pagination.total),
    },
  }),
};

const retrieveQuestionnaire = {
  fe2be: R.identity,
  be2fe: ({ value: questionnaire }) => ({
    questionnaire,
  }),
};

const retrieveAvailableQuestionnaireTemplates = {
  fe2be: R.identity,
  be2fe: ({ value: availableQuestionnaireTemplates }) => ({
    availableQuestionnaireTemplates,
  }),
};

const deleteQuestionnaireTemplate = {
  fe2be: R.identity,
  be2fe: ({ value }) => value,
};

const retrieveEnrolledQuestionnaires = {
  fe2be: R.identity,
  be2fe: ({ value }) => value,
};

const retrieveStandaloneQuestionnaireTasks = {
  fe2be: R.identity,
  be2fe: ({ value }) => value,
};

const enrollQuestionnaire = {
  fe2be: ({
    information: {
      patientId,
      questionnaireTemplateId,
      period: { start: startDate, end: endDate } = {},
      scoreType: { value: scoreType },
    },
    careteams,
    additionalMembers,
    thresholds: {
      onlineThreshold: { threshold: onlineThreshold, alerts: onlineAlerts },
      offlineThreshold: { threshold: offlineThreshold, alerts: offlineAlerts },
      defaultAlerts: { alerts: defaultAlerts },
      schedule: {
        type: { value: scheduleType },
        frequency,
        timeslots,
        meals,
      },
    },
    summary: {
      hasOfflineSetting,
      onlineMinTotalPoints,
      onlineMaxTotalPoints,
      offlineMinTotalPoints,
      offlineMaxTotalPoints,
    },
  }) => {
    let thresholds = null;
    if (scoreType === 'NOT_APPLICABLE') {
      thresholds = {
        default: null,
      };
    } else {
      thresholds = {
        online: [
          onlineThreshold.criticallyLow,
          onlineThreshold.low,
          onlineThreshold.high,
          onlineThreshold.criticallyHigh,
        ],
        offline: !hasOfflineSetting
          ? null
          : (offlineThreshold.criticallyLow === 0 || offlineThreshold.criticallyLow === null) &&
            (offlineThreshold.low === 0 || offlineThreshold.low === null) &&
            (offlineThreshold.high === 0 || offlineThreshold.high === null) &&
            (offlineThreshold.criticallyHigh === 0 || offlineThreshold.criticallyHigh === null)
          ? null
          : [
              offlineThreshold.criticallyLow,
              offlineThreshold.low,
              offlineThreshold.high,
              offlineThreshold.criticallyHigh,
            ],
      };
    }

    const payloadToServer = {
      startDate: moment(startDate).format('YYYY-MM-DD'),
      patientId: Number(patientId),
      questionnaireTemplateId,
      careteam: {
        careTeamId: Array.isArray(careteams) && careteams[0].id,
        additionalMemberIds: additionalMembers.map((e) => e.profile.id),
      },
      thresholds,
      alerts:
        scoreType === 'NOT_APPLICABLE'
          ? [...parseAlerts(defaultAlerts, 'DEFAULT')]
          : [...parseAlerts(onlineAlerts, 'ONLINE'), ...parseAlerts(offlineAlerts, 'OFFLINE')],
      schedule: {
        scheduleType: {
          frequency: 'FREQUENCY',
          timeslots: 'TIMESLOT',
          meals: 'TIMESLOT_MEAL',
        }[scheduleType],
        scheduleDetails: (() => {
          switch (scheduleType) {
            case 'frequency':
              return {
                frequency: {
                  calendar: R.path(['calendar', 'value'], frequency),
                  times: R.path(['times'], frequency),
                },
              };
            case 'timeslots':
              return {
                timeslot: R.map(
                  ({ from, to }) => ({
                    start: `${String(moment(from).hour()).padStart(2, '0')}${String(moment(from).minute()).padStart(
                      2,
                      '0',
                    )}`,
                    end: `${String(moment(to).hour()).padStart(2, '0')}${String(moment(to).minute()).padStart(2, '0')}`,
                  }),
                  timeslots,
                ),
              };
            case 'meals':
              return {
                timeslotMeal: {
                  calendar: 'DAILY',
                  timeslots: (({
                    before: { checkeds: beforeCheckeds = {} } = {},
                    after: { checkeds: afterCheckeds = {} } = {},
                  }) =>
                    R.pipe(
                      R.ap([R.pipe(R.filter(R.identity), R.keys)]),
                      R.flatten,
                      R.map((meal) => ({ meal, times: 1 })),
                    )([beforeCheckeds, afterCheckeds]))(meals),
                },
              };
            default:
              return {};
          }
        })(),
      },
      summary: {
        online: {
          maxScore: onlineMaxTotalPoints,
          minScore: onlineMinTotalPoints,
        },
        offline: {
          maxScore: offlineMaxTotalPoints,
          minScore: offlineMinTotalPoints,
        },
      },
    };

    console.log('>> enrollQuestionnaire payloadToServer: ', payloadToServer);

    return payloadToServer;
  },
  // be2fe: ({ value: questionnaire }) => {
  //   return questionnaire;
  // },
  be2fe: R.identity,
};

const dischargeQuestionnaireEnrollment = {
  fe2be: ({ information: { dischargeReason } }) => {
    return { reason: dischargeReason };
  },
  be2fe: R.identity,
};

const updateQuestionnaireEnrollment = {
  fe2be: ({
    information: {
      scoreType: { value: scoreType },
    },
    careteams,
    additionalMembers,
    thresholds: {
      onlineThreshold: { threshold: onlineThreshold, alerts: onlineAlerts },
      offlineThreshold: { threshold: offlineThreshold, alerts: offlineAlerts },
      defaultAlerts: { alerts: defaultAlerts },
      schedule: {
        type: { value: scheduleType },
        frequency,
        timeslots,
        meals,
      },
    },
    summary: {
      hasOfflineSetting,
      onlineMinTotalPoints,
      onlineMaxTotalPoints,
      offlineMinTotalPoints,
      offlineMaxTotalPoints,
    },
  }) => {
    let thresholds = null;
    if (scoreType === 'NOT_APPLICABLE') {
      thresholds = {
        default: null,
      };
    } else {
      thresholds = {
        online: [
          onlineThreshold.criticallyLow,
          onlineThreshold.low,
          onlineThreshold.high,
          onlineThreshold.criticallyHigh,
        ],
        offline: !hasOfflineSetting
          ? null
          : (offlineThreshold.criticallyLow === 0 || offlineThreshold.criticallyLow === null) &&
            (offlineThreshold.low === 0 || offlineThreshold.low === null) &&
            (offlineThreshold.high === 0 || offlineThreshold.high === null) &&
            (offlineThreshold.criticallyHigh === 0 || offlineThreshold.criticallyHigh === null)
          ? null
          : [
              offlineThreshold.criticallyLow,
              offlineThreshold.low,
              offlineThreshold.high,
              offlineThreshold.criticallyHigh,
            ],
      };
    }

    const payloadToServer = {
      thresholds,
      alerts:
        scoreType === 'NOT_APPLICABLE'
          ? [...parseAlerts(defaultAlerts, 'DEFAULT')]
          : [...parseAlerts(onlineAlerts, 'ONLINE'), ...parseAlerts(offlineAlerts, 'OFFLINE')],
      schedule: {
        scheduleType: {
          frequency: 'FREQUENCY',
          timeslots: 'TIMESLOT',
          meals: 'TIMESLOT_MEAL',
        }[scheduleType],
        scheduleDetails: (() => {
          switch (scheduleType) {
            case 'frequency':
              return {
                frequency: {
                  calendar: R.path(['calendar', 'value'], frequency),
                  times: R.path(['times'], frequency),
                },
              };
            case 'timeslots':
              return {
                timeslot: R.map(
                  ({ from, to }) => ({
                    start: `${String(moment(from).hour()).padStart(2, '0')}${String(moment(from).minute()).padStart(
                      2,
                      '0',
                    )}`,
                    end: `${String(moment(to).hour()).padStart(2, '0')}${String(moment(to).minute()).padStart(2, '0')}`,
                  }),
                  timeslots,
                ),
              };
            case 'meals':
              return {
                timeslotMeal: {
                  calendar: 'DAILY',
                  timeslots: (({
                    before: { checkeds: beforeCheckeds = {} } = {},
                    after: { checkeds: afterCheckeds = {} } = {},
                  }) =>
                    R.pipe(
                      R.ap([R.pipe(R.filter(R.identity), R.keys)]),
                      R.flatten,
                      R.map((meal) => ({ meal, times: 1 })),
                    )([beforeCheckeds, afterCheckeds]))(meals),
                },
              };
            default:
              return {};
          }
        })(),
      },
    };

    console.log('>> updateQuestionnaireEnrollment payloadToServer 1: ', payloadToServer);

    if (Array.isArray(careteams) && careteams.length > 0) {
      payloadToServer.careteam = {
        careTeamId: (careteams[0] && careteams[0].id) || Number(careteams[0]) || null,
        additionalMemberIds: Array.isArray(additionalMembers)
          ? additionalMembers.map(function(e) {
              return e.profile.id;
            })
          : [],
      };
    }

    console.log('>> updateQuestionnaireEnrollment payloadToServer 2: ', payloadToServer);

    return payloadToServer;
  },
  // be2fe: ({ value: questionnaire }) => {
  //   return questionnaire;
  // },
  be2fe: R.identity,
};

const retrieveQuestionnaireEnrollment = {
  fe2be: R.identity,
  be2fe: ({ value: enrolledProgram }) => ({
    enrolledProgram: {
      ...enrolledProgram,
      additionalMembers: enrolledProgram.additionalMembers.map((member) => ({
        profile: {
          id: member.provider.id,
          role: {
            value: ROLE_MAPPING.find((r) => r.id === member.provider.type).value,
            label: ROLE_MAPPING.find((r) => r.id === member.provider.type).label,
          },
          orgId: member.provider.orgId,
          speciality: {
            value: member.provider.speciality,
            label: member.provider.speciality,
          },
        },
        demographic: {
          id: member.provider.id,
          mobile: {
            value: member.provider.currentDemographics.mobile.value,
            countryCode: member.provider.currentDemographics.mobile.countryCode,
          },
          identity: {
            avatar: member.provider.currentDemographics.profile_photo,
            firstName: member.provider.currentDemographics.name.firstName,
            lastName: member.provider.currentDemographics.name.lastName,
          },
        },
        primary: member.isPrimary,
      })),
    },
  }),
};

const retrieveQuestionnaireResults = {
  fe2be: R.identity,
  be2fe: ({ value }) => value,
};

const retrieveQuestionnaireResponse = {
  fe2be: R.identity,
  be2fe: ({ value }) => value,
};

const createQuestionnaireNote = {
  fe2be: R.identity,
  be2fe: ({ value }) => value,
};

const retrieveQuestionnaireNotes = {
  fe2be: R.identity,
  be2fe: ({ value }) => value,
};

const markQuestionnaireNoteAsError = {
  fe2be: R.identity,
  be2fe: ({ value }) => value,
};

export default {
  createQuestionnaire,
  updateQuestionnaire,
  retrieveQuestionnaires,
  retrieveQuestionnaire,
  retrieveAvailableQuestionnaireTemplates,
  deleteQuestionnaireTemplate,
  retrieveEnrolledQuestionnaires,
  retrieveStandaloneQuestionnaireTasks,
  enrollQuestionnaire,
  updateQuestionnaireEnrollment,
  retrieveQuestionnaireEnrollment,
  retrieveQuestionnaireResults,
  dischargeQuestionnaireEnrollment,
  retrieveQuestionnaireResponse,
  createQuestionnaireNote,
  retrieveQuestionnaireNotes,
  markQuestionnaireNoteAsError,
};
